export default  {
    component: 'scb_param',
    name: 'scb_param',
    fields: [
        {
            param: 'plant_id',
            type: 'number',
            required: true,
            identifier: true,
            hidden: true
          },
          {
            name: 'Role',
            param: 'role',
            type: 'text',
            description: `We need to add 3 types of roles:
            - **user** 
            - **admin** 
            - **super-admin**`
          },
          {
            name: 'Module',
            param: 'module',
            type: 'text',
            description: `Their are 2 options for module:
            - **analytics**
            - **live**
            We need to add module for each roles`
          },
          {
            name: 'Parameters',
            param: 'parameters',
            type: 'text',
            description: `Option for parameters are displayed as follows::
            - **live** [Parameter Options : voltage,dc_power,total_string_current,temperature]
            - **analytics** [Parameter Options :  current, total_string_current, voltage, dc_power, temperature]`
          }
    ]
  }
